import script from "./PatternLock.vue?vue&type=script&setup=true&lang=js"
export * from "./PatternLock.vue?vue&type=script&setup=true&lang=js"

import "./PatternLock.vue?vue&type=style&index=0&id=5a952b36&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a952b36"]])

export default __exports__